import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import ProductCard from '@/components/base/product-card'
import Spacer from '@/components/sections/spacer'
import TextBlock from '@/components/sections/text-block'

import { productsGridRevealAnimation } from './animations'
import { WPLink } from '@/types'

export type ProductsGridProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    subtitle: string
    paragraph: string
    alignment: 'left' | 'right'
    products: {
      title: string
      excerpt: string
      link: WPLink
    }[]
  }>

const ProductsGrid = ({
  title,
  subtitle,
  paragraph,
  alignment,
  products,
  ...props
}: ProductsGridProps) => {
  return (
    <section {...props}>
      <TextBlock
        title={title}
        paragraph_1={subtitle}
        paragraph_2={paragraph}
        alignment={alignment}
      />
      <Spacer variant="md" />
      <Motion animation={productsGridRevealAnimation}>
        {(motionRef) => (
          <Container ref={motionRef}>
            <Grid className="items-center gap-y-spacing-lg">
              <div className="col-span-2 md:col-span-6 lg:col-span-12">
                <div className="grid grid-cols-2 gap-spacing-xs md:grid-cols-3">
                  {products?.map((item, index) => (
                    <div
                      key={`product-card-${index}`}
                      className="col-span-2 md:col-span-1"
                    >
                      <ProductCard
                        title={item.title}
                        paragraph={item.excerpt}
                        link={item.link}
                        data-motion-card
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Grid>
          </Container>
        )}
      </Motion>
    </section>
  )
}

export default ProductsGrid
